module.exports = __webpack_public_path__ + "static/Secret-sales-8a85f30c888cf47a65d09e0e46d27795.svg";